(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cl-collections"]) return;
  try {
    
(() => {
  const normalize = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const initDirectories = () => {
    document.querySelectorAll('[data-set-directory]').forEach((directory) => {
      if (directory.dataset.setDirectoryReady) return;
      const tablist = directory.querySelector('[data-shop-tabs]');
      const tabs = Array.from(directory.querySelectorAll('[data-shop-tab]'));
      const panels = Array.from(directory.querySelectorAll('[data-shop-panel]'));
      const jump = directory.querySelector('[data-vanguard-jump]');
      if (tablist && tabs.length && panels.length) {
        tablist.setAttribute('role', 'tablist');
        tabs.forEach((tab) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.dataset.shopTab);
        });
        panels.forEach((panel) => panel.setAttribute('role', 'tabpanel'));
        const selectTab = (name) => {
          const selected = tabs.some((tab) => tab.dataset.shopTab === name) ? name : 'Vanguard';
          tabs.forEach((tab) => {
            const active = tab.dataset.shopTab === selected;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          panels.forEach((panel) => { panel.hidden = panel.dataset.shopPanel !== selected; });
          if (jump) jump.hidden = selected !== 'Vanguard';
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            selectTab(tab.dataset.shopTab);
            history.pushState(null, '', tab.getAttribute('href'));
          });
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            tabs[next].focus();
            tabs[next].click();
          });
        });
        window.addEventListener('hashchange', () => selectTab(location.hash.slice(1)));
        window.addEventListener('popstate', () => selectTab(location.hash.slice(1)));
        selectTab(location.hash.slice(1));
      }
      const input = directory.querySelector('[data-set-search-input]');
      const cards = Array.from(directory.querySelectorAll('[data-set-card]')).map((element) => ({
        element,
        search: normalize(element.dataset.setSearch || ''),
        series: element.dataset.setSeriesValue
      }));
      const buttons = Array.from(directory.querySelectorAll('[data-set-series]'));
      const clear = directory.querySelector('[data-set-clear]');
      const count = directory.querySelector('[data-set-count]');
      const empty = directory.querySelector('[data-set-empty]');
      if (!input || !clear || !count || !empty) return;
      let series = 'all';
      const update = () => {
        const words = input.value.trim().split(/\s+/).map(normalize).filter(Boolean);
        let visible = 0;
        cards.forEach((card) => {
          const matches = (series === 'all' || card.series === series) && words.every((word) => card.search.includes(word));
          card.element.hidden = !matches;
          if (matches) visible += 1;
        });
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.setSeries === series)));
        clear.hidden = input.value.length === 0;
        count.textContent = String(visible);
        empty.hidden = visible !== 0;
      };
      input.addEventListener('input', update);
      input.addEventListener('search', update);
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        input.value = '';
        update();
      });
      clear.addEventListener('click', () => {
        input.value = '';
        update();
        input.focus();
      });
      buttons.forEach((button) => {
        button.hidden = button.dataset.setSeries !== 'all' && !cards.some((card) => card.series === button.dataset.setSeries);
        button.addEventListener('click', () => {
          series = button.dataset.setSeries;
          update();
        });
      });
      directory.querySelector('[data-set-reset]').addEventListener('click', () => {
        input.value = '';
        series = 'all';
        update();
        input.focus();
      });
      directory.dataset.setDirectoryReady = 'true';
      directory.querySelector('[data-set-tools]').hidden = false;
      directory.querySelector('[data-set-results]').hidden = false;
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDirectories);
  else initDirectories();
  document.addEventListener('shopify:section:load', initDirectories);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cl-product-recommendations')) {
    customElements.define('cl-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded || !this.dataset.url) return;
        this.loaded = true;
        this.loadRecommendations();
      }
      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const recommendations = html.querySelector('cl-product-recommendations');
          if (!this.isConnected || !recommendations?.querySelector('.cl-product-card')) return;
          this.innerHTML = recommendations.innerHTML;
          this.hidden = false;
          this.dispatchEvent(new CustomEvent('cl:products:loaded', { bubbles: true }));
        } catch {
          return;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clhp-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const revealGuideAnchor = () => {
      const anchor = window.location.hash.slice(1);
      if (anchor !== 'CrestlaneDelivery' && anchor !== 'CrestlanePriceReference') return;
      const target = document.getElementById(anchor);
      const guide = target?.closest('[data-clhp-full-guide]');
      if (!guide) return;
      guide.open = true;
      window.requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    };
    window.addEventListener('hashchange', revealGuideAnchor);
    document.addEventListener('shopify:section:load', revealGuideAnchor);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealGuideAnchor, { once: true });
    } else {
      revealGuideAnchor();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
